<template>
    <div class="home__header">
        <div class="home__header-logo-box">
            <img class="home__header-logo" :src="`${$store.state.config.setup.logo}`" />
        </div>
        <!-- <span class="home__header-verison">
            {{ getTranslatedText("verison") }}: {{ $store.state.versionApp }}
        </span> -->
        <!-- <p class="home__header-text">
            {{ getTranslatedText("dashboard") }}
        </p> -->
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],

    data() {
        return {};
    },
    methods: {},
};
</script>
